import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  DateField,
  ListProps,
  SelectInput,
  FunctionField,
  DateInput,
} from 'react-admin';
import { Chip } from '@mui/material';
import useAuthorize from '../hooks/useAuthorize';
import { WEBSITE_MODULE_ROLES } from '../roles/portalRoles';

const filters = [
  <TextInput label="Search" source="q" alwaysOn key="q" resettable />,
  <TextInput label="Name" source="contact_name" key="contact_name" resettable />,
  <TextInput label="Phone" source="phone_number" key="phone_number" resettable />,
  <TextInput label="Email" source="email_address" key="email_address" resettable />,
  <DateInput label="Logged Date" source="created_date" key="created_date" />,
  <SelectInput
    label="Notification"
    source="notification_status"
    key="notification_status"
    resettable
    choices={[
      { id: 'sent', name: 'Sent' },
      { id: 'partial', name: 'Partial' },
      { id: 'failed', name: 'Failed' },
      { id: 'skipped', name: 'Skipped' },
      { id: 'pending', name: 'Pending' },
    ]}
  />,
];

const NotificationStatusField = ({ record }: { record?: any }) => {
  if (!record) return null;
  const status = String(record.notification_status || 'pending').toLowerCase();
  const colorMap: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
    sent: 'success',
    partial: 'warning',
    failed: 'error',
    skipped: 'default',
    pending: 'default',
  };
  return <Chip label={status} color={colorMap[status] || 'default'} size="small" />;
};

export const CustomerContactList: React.FC<ListProps> = (props) => {
  useAuthorize(WEBSITE_MODULE_ROLES);

  return (
    <List
      {...props}
      filters={filters}
      sort={{ field: 'created_at', order: 'DESC' }}
      perPage={25}
      title="Customer Contact"
    >
      <Datagrid bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <TextField source="contact_name" label="Name" />
        <TextField source="phone_number" label="Phone" />
        <TextField source="email_address" label="Email" />
        <FunctionField
          label="Message"
          render={(record: any) => (record?.message_text ? record.message_text : '-')}
        />
        <DateField source="created_at" label="Logged Time" showTime />
        <FunctionField
          label="Notification"
          render={(record: any) => <NotificationStatusField record={record} />}
        />
        <TextField source="notification_error" label="Notification Error" />
      </Datagrid>
    </List>
  );
};

export default CustomerContactList;
